var render = function render(_c,_vm){return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle, {height: _vm.props.height || '', width: _vm.props.width || ''}]),attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"xlink:href":`#${_vm.props.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }